import Project from "../components/Project.jsx";
import { ProjectLinks, ProjectLink } from "../components/ProjectLinks.jsx";
import { Typography } from "@mui/material";

export default function Main() {
  return (
    <Project
      title="Parliment History"
      picture={
        <img
          alt="verification page"
          className="project-img"
          src={require("../pictures/proximus.png")}
          width={400}
        />
      }
      text={
        <Typography align="justify" sx={styles.text}>
          Senior capstone project. Created and deployed an online tool to
          organize the research of parliment history for a client, who is an
          Econ professor at Hamilton College. Core features include a webscraped
          database of the source texts and page verification with text and
          image. Built using React, Node.js, MongoDB, and hosted on Render.
        </Typography>
      }
      links={
        <ProjectLinks>
          <ProjectLink link="https://react-fe-2xnv.onrender.com">
            Proximus
          </ProjectLink>

          <ProjectLink link="/proximus-slide">Presentation</ProjectLink>
        </ProjectLinks>
      }
    />
  );
}

const styles = {
  text: {
    width: 0.9,
    fontSize: 20,
  },
};
